var _rect, _polygon, _rect2, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _rect3, _polygon7, _polygon8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPA5(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 990 720"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    "data-id": "A.5.1",
    x: 254,
    y: 379,
    width: 88,
    height: 126
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "A.5.2",
    points: "249.24 379 249.24 540 191.06 540 191.06 505 104 505 104 379 249.24 379"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    "data-id": "A.5.3",
    x: 92,
    y: 184,
    width: 130,
    height: 190
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "A.5.4",
    points: "225.93 184 342 184 342 339 251.98 339 251.98 329 225.93 329 225.93 184"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "A.5.5",
    points: "347 202 463 202 463 329 438.06 329 438.06 339 347 339 347 202"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "A.5.6",
    points: "467.61 202 584 202 584 339 493 339 493 329 468 329 467.61 202"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "A.5.7",
    points: "587.96 202 704 202 704 329 679 329 679 339 587.96 339 587.96 202"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "A.5.8",
    points: "709 214 885 214 885 374 805 374 805 339 709 339 709 214"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    "data-id": "A.5.9",
    x: 709,
    y: 379,
    width: 188,
    height: 155
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "A.5.10",
    points: "703.92 379 703.92 516 646 516 646 552 588 552 588 389 613 389 613 379 703.92 379"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "A.5.11",
    points: "584 389 584 552 526.09 552 526.09 516.13 467 516.13 467 379 558.27 379 558.27 389 584 389"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyAKICAgIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgCiAgICB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgCiAgICB2aWV3Qm94PSIwIDAgOTkwIDcyMCIKPgogICAgPHJlY3QgZGF0YS1pZD0iQS41LjEiIHg9IjI1NCIgeT0iMzc5IiB3aWR0aD0iODgiIGhlaWdodD0iMTI2Ii8+CiAgICA8cG9seWdvbiBkYXRhLWlkPSJBLjUuMiIgcG9pbnRzPSIyNDkuMjQgMzc5IDI0OS4yNCA1NDAgMTkxLjA2IDU0MCAxOTEuMDYgNTA1IDEwNCA1MDUgMTA0IDM3OSAyNDkuMjQgMzc5Ii8+CiAgICA8cmVjdCBkYXRhLWlkPSJBLjUuMyIgeD0iOTIiIHk9IjE4NCIgd2lkdGg9IjEzMCIgaGVpZ2h0PSIxOTAiLz4KICAgIDxwb2x5Z29uIGRhdGEtaWQ9IkEuNS40IiBwb2ludHM9IjIyNS45MyAxODQgMzQyIDE4NCAzNDIgMzM5IDI1MS45OCAzMzkgMjUxLjk4IDMyOSAyMjUuOTMgMzI5IDIyNS45MyAxODQiLz4KICAgIDxwb2x5Z29uIGRhdGEtaWQ9IkEuNS41IiBwb2ludHM9IjM0NyAyMDIgNDYzIDIwMiA0NjMgMzI5IDQzOC4wNiAzMjkgNDM4LjA2IDMzOSAzNDcgMzM5IDM0NyAyMDIiLz4KICAgIDxwb2x5Z29uIGRhdGEtaWQ9IkEuNS42IiBwb2ludHM9IjQ2Ny42MSAyMDIgNTg0IDIwMiA1ODQgMzM5IDQ5MyAzMzkgNDkzIDMyOSA0NjggMzI5IDQ2Ny42MSAyMDIiLz4KICAgIDxwb2x5Z29uIGRhdGEtaWQ9IkEuNS43IiBwb2ludHM9IjU4Ny45NiAyMDIgNzA0IDIwMiA3MDQgMzI5IDY3OSAzMjkgNjc5IDMzOSA1ODcuOTYgMzM5IDU4Ny45NiAyMDIiLz4KICAgIDxwb2x5Z29uIGRhdGEtaWQ9IkEuNS44IiBwb2ludHM9IjcwOSAyMTQgODg1IDIxNCA4ODUgMzc0IDgwNSAzNzQgODA1IDMzOSA3MDkgMzM5IDcwOSAyMTQiLz4KICAgIDxyZWN0IGRhdGEtaWQ9IkEuNS45IiB4PSI3MDkiIHk9IjM3OSIgd2lkdGg9IjE4OCIgaGVpZ2h0PSIxNTUiLz4KICAgIDxwb2x5Z29uIGRhdGEtaWQ9IkEuNS4xMCIgcG9pbnRzPSI3MDMuOTIgMzc5IDcwMy45MiA1MTYgNjQ2IDUxNiA2NDYgNTUyIDU4OCA1NTIgNTg4IDM4OSA2MTMgMzg5IDYxMyAzNzkgNzAzLjkyIDM3OSIvPgogICAgPHBvbHlnb24gZGF0YS1pZD0iQS41LjExIiBwb2ludHM9IjU4NCAzODkgNTg0IDU1MiA1MjYuMDkgNTUyIDUyNi4wOSA1MTYuMTMgNDY3IDUxNi4xMyA0NjcgMzc5IDU1OC4yNyAzNzkgNTU4LjI3IDM4OSA1ODQgMzg5Ii8+Cjwvc3ZnPg==";
export { SvgPA5 as ReactComponent };